import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import React, { useState, useEffect } from 'react'
import './ApplyV2LanguageStep.scss'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { EducationIcon } from './icons/icon'
import { TrashIcon } from './icons/trash_icon'
import getLanguageDataById from '@core/utils/helpers/getLanguageDataById'
import {
    usePostLanguageV2ApplyMutation,
    usePutLanguageV2ApplyMutation,
    useDeleteLanguageV2ApplyMutation,
} from '@core/app/api/applyJobV2Api'
import LanguagePickerModal from './LanguagePickerModal'
import ApplyV2SelectForLanguage from '@core/components/ApplyDialogV2/ApplyV2SelectForLanguage'
import { Tooltip } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'



const baseClass = 'LanguageStep'

const LanguageStep: React.FC = () => {
    const { t } = useTranslation()
    const { getTitle } = useApplyV2NavTranslations()
    const { postProfileData, onNextStep, settingsData } = useApplyV2Context()
    const uid = postProfileData?.data?.uid

    const [postLanguage] = usePostLanguageV2ApplyMutation()
    const [putLanguage] = usePutLanguageV2ApplyMutation()
    const [deleteLanguage] = useDeleteLanguageV2ApplyMutation()

    const [languages, setLanguages] = useState(postProfileData?.data?.language || [])
    const [showModal, setShowModal] = useState(false)

    const handleAddClick = () => {
        setShowModal(true)
    }

    const [openUid, setOpenUid] = useState<string | null>(null)

    const LANGUAGE_LEVELS = [
        { label: t('10597', 'Elementary'), value: 1 },
        { label: t('10598', 'Limited working'), value: 2 },
        { label: t('10599', 'Professional working'), value: 3 },
        { label: t('10600', 'Full professional'), value: 4 },
        { label: t('10601', 'Native or bilingual'), value: 5 },
    ]

    const handleLevelChange = async (languageUid: string, level: number) => {
        if (!uid) return
        try {
            await putLanguage({
                uid,
                body: { uid: languageUid, languageLevelId: level },
            }).unwrap()
            setLanguages((prev) =>
                prev.map((lang) => (lang.uid === languageUid ? { ...lang, languageLevelId: level } : lang))
            )
        } catch (e) {
            console.error('Failed to update language level', e)
        }
    }

    const handleDelete = async (languageUid: string) => {
        if (!uid) return
        try {
            await deleteLanguage({ uid: uid, LangUid: languageUid }).unwrap()
            setLanguages((prev) => prev.filter((lang) => lang.uid !== languageUid))
        } catch (e) {
            console.error('Failed to delete language', e)
        }
    }

    const handleLanguageSelect = async (languageId: number) => {
        if (!uid) return
        try {
            const res = await postLanguage({
                uid,
                body: { worldLanguageId: languageId, languageLevelId: 3 },
            }).unwrap()
            const newLang = res?.data?.language
            if (newLang) {
                setLanguages((prev) => [...prev, newLang])
                setOpenUid(newLang.uid)
                setTimeout(() => {
                    document
                        .getElementById(`lang-item-${newLang.uid}`)
                        ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
                }, 0)
            }
        } catch (e) {
            console.error('Failed to add language', e)
        } finally {
            setShowModal(false)
        }
    }

    useEffect(() => {
        setLanguages(postProfileData?.data?.language || [])
    }, [postProfileData])

    return (
        <div className="LanguageStep">
            {languages.length === 0 ? (
                <>
                    <div className={`${baseClass}__edu-empty ${baseClass}__empty`}>
                        <div className={`${baseClass}__edu-empty-icon ${baseClass}__empty--icon`}>
                            <EducationIcon />
                        </div>
                        <div className={`${baseClass}__edu-empty-content ${baseClass}__empty--content`}>
                            <div className={`${baseClass}__edu-empty-title ${baseClass}__empty--content-title`}>
                                {t('10596', ' No languages added yet')}
                            </div>
                            <div className={`${baseClass}__edu-empty-actions ${baseClass}__empty--content-actions`}>
                                <button
                                    className={`${baseClass}__edu-empty__add-edu-btn`}
                                    type="button"
                                    onClick={handleAddClick}
                                >
                                    + {t('10605', 'Add language')}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/*<div className="row right">*/}
                    {/*    <button type="button" disabled className="next-btn" onClick={onNextStep}>*/}
                    {/*        Next*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    <div className={`ApplyDialogV2__next ${baseClass}__next`}>
                        {!settingsData?.steps?.language?.required && (
                            <ApplyV2Button
                                variant={'transparent'}
                                className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-skip`}
                                rightIcon={'>'}
                                // isDisabled={!isValid || isLoading}
                                onClick={() => {
                                    onNextStep()
                                }}
                            >
                                {getTitle('6107', 'Skip')}
                            </ApplyV2Button>
                        )}
                        <ApplyV2Button
                            type="submit"
                            variant={'primary'}
                            className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-submit`}
                            onClick={onNextStep}
                            // isLoading={isPostApplied || isPostProfileLoading}
                            isDisabled={true}
                        >
                            {getTitle('3035', 'Next')}
                        </ApplyV2Button>
                    </div>
                </>
            ) : (
                <>
                    <div className="list">
                        {languages.map((lang) => {
                            const langData = getLanguageDataById(lang.worldLanguageId)
                            return (
                                <div key={lang.uid} className="block">
                                    <div className="language_item">
                                        <div className="title">
                                            {/* {langData?.flag && <img src={langData.flag} alt="" className="flag-icon" />}  */}
                                            {langData?.name || 'Unknown'}
                                        </div>
                                        <div className="field">
                                            <ApplyV2SelectForLanguage
                                                value={lang.languageLevelId}
                                                className="select"
                                                options={[
                                                    { value: 1, label: t('10597', 'Elementary') },
                                                    { value: 2, label: t('10598', 'Limited working') },
                                                    { value: 3, label: t('10599', 'Professional working') },
                                                    { value: 4, label: t('10600', 'Full professional') },
                                                    { value: 5, label: t('10601', 'Native or bilingual') },
                                                ]}
                                                onChange={(val) => {
                                                    const levelValue = Number(val)
                                                    if ([1, 2, 3, 4, 5].includes(levelValue)) {
                                                        handleLevelChange(lang.uid, levelValue as 1 | 2 | 3 | 4 | 5)
                                                    }
                                                    setOpenUid(null)
                                                }}
                                                placeholder="Select level"
                                                isClearable={false}
                                                isSearchable={false}
                                                menuIsOpen={openUid === lang.uid}
                                                onMenuOpen={() => setOpenUid(lang.uid)}
                                                onMenuClose={() => setOpenUid(null)}
                                                autoFocus={openUid === lang.uid}
                                                openMenuOnFocus
                                            />
                                        </div>
                                    </div>
                                    <div className="actions">
                                        <div className="field">
                                            <Tooltip
                                                hasArrow
                                                openDelay={500}
                                                label={getTitle('37', 'Delete')}
                                                padding={'8px 16px'}
                                                borderRadius={'4px'}
                                                backgroundColor={'#19191A'}
                                                fontWeight={600}
                                                fontSize={'12px'}
                                                shouldWrapChildren
                                            >
                                                <button
                                                    type="button"
                                                    className="icon-btn icon-btn--delete"
                                                    onClick={() => handleDelete(lang.uid)}
                                                    aria-label={getTitle('37', 'Delete')}
                                                >
                                                    <TrashIcon />
                                                </button>
                                            </Tooltip>
                                        </div>

                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="edu-empty-actions">
                        <button className="add-edu-btn" type="button" onClick={handleAddClick}>
                            + {t('10605', 'Add language')}
                        </button>
                    </div>

                    <div className="row right">
                        <button type="button" className="next-btn" onClick={onNextStep}>
                            {getTitle('3035', 'Next')}
                        </button>
                    </div>
                </>
            )}

            {/* Language Picker Modal */}
            {showModal && (
                <LanguagePickerModal
                    onClose={() => setShowModal(false)}
                    onSelect={handleLanguageSelect}
                    excludeIds={languages.map((l) => l.worldLanguageId)}
                />
            )}
        </div>
    )
}

export default LanguageStep
